import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=036ae1ab"
import script from "./PageContainer.vue?vue&type=script&lang=ts"
export * from "./PageContainer.vue?vue&type=script&lang=ts"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=036ae1ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports